import { BANNER_TYPES } from "./heroBannerConstants";

export const getBannerId = (item) => item?.id ?? item?.Id;

export const getBannerName = (item) =>
  item?.bannerName || item?.BannerName || "-";

export const getBannerType = (item) =>
  item?.bannerType || item?.BannerType || "-";

export const getBannerTitle = (item) =>
  item?.bannerTitle || item?.BannerTitle || "-";

export const getDisplayOrder = (item) =>
  item?.displayOrder ?? item?.DisplayOrder ?? "-";

export const getDesktopImageUrl = (item) =>
  item?.desktopImageUrl || "";

export const getMobileImageUrl = (item) =>
  item?.mobileImageUrl || item?.MobileImageUrl || "";

export const formatBannerStatus = (item) => {
  if (item?.status !== undefined && item?.status !== null) {
    return String(item.status);
  }
  const active = item?.isActive ?? item?.IsActive;
  if (active === true || active === "true" || active === 1) return "Active";
  if (active === false || active === "false" || active === 0) return "Inactive";
  return "Active";
};

export const extractListResult = (response) => {
  const data = response?.data;
  const list = data?.result ?? data?.data ?? data ?? [];
  return Array.isArray(list) ? list : [];
};

export const extractMutationId = (response) => {
  const data = response?.data;
  const result = data?.result;

  if (typeof result === "number" || typeof result === "string") {
    return result;
  }

  if (result && typeof result === "object") {
    return result.id ?? result.Id ?? result.bannerId ?? result.BannerId;
  }

  return data?.id ?? data?.Id ?? data?.bannerId ?? data?.BannerId;
};

export const getButtonId = (btn) => btn?.id ?? btn?.Id;

export const getButtonBannerId = (btn) =>
  btn?.heroBannerId ?? btn?.HeroBannerId;

export const normalizeButton = (btn, index = 0) => ({
  clientId: `existing-${getButtonId(btn) || index}`,
  id: getButtonId(btn) || null,
  buttonLabel: btn?.buttonLabel || btn?.ButtonLabel || "",
  buttonUrl: btn?.buttonUrl || btn?.ButtonUrl || "",
  buttonStyle: btn?.buttonStyle || btn?.ButtonStyle || "",
  displayOrder:
    btn?.displayOrder ??
    btn?.DisplayOrder ??
    btn?.buttonOrder ??
    btn?.ButtonOrder ??
    index + 1,
});

export const normalizeBannerToForm = (banner, buttons = []) => {
  const active = banner?.isActive ?? banner?.IsActive;
  return {
    bannerName: banner?.bannerName || banner?.BannerName || "",
    bannerType: banner?.bannerType || banner?.BannerType || BANNER_TYPES.IMAGE,
    bannerTitle: banner?.bannerTitle || banner?.BannerTitle || "",
    bannerDescription:
      banner?.bannerDescription || banner?.BannerDescription || "",
    displayOrder: String(
      banner?.displayOrder ?? banner?.DisplayOrder ?? ""
    ),
    isActive:
      active === undefined || active === null
        ? true
        : active === true || active === "true" || active === 1,
    desktopImageFile: null,
    mobileImageFile: null,
    desktopImagePreview: getDesktopImageUrl(banner),
    mobileImagePreview: getMobileImageUrl(banner),
    buttons: (buttons.length ? buttons : banner?.buttons || []).map(
      normalizeButton
    ),
  };
};

export const getButtonLabel = (btn) =>
  btn?.buttonLabel || btn?.ButtonLabel || "-";

export const getButtonUrl = (btn) => btn?.buttonUrl || btn?.ButtonUrl || "-";

export const getButtonStyle = (btn) =>
  btn?.buttonStyle || btn?.ButtonStyle || "-";

export const getButtonOrder = (btn) =>
  btn?.displayOrder ??
  btn?.DisplayOrder ??
  btn?.buttonOrder ??
  btn?.ButtonOrder ??
  "-";

export const formatButtonStatus = (btn) => {
  if (btn?.status !== undefined && btn?.status !== null) {
    return String(btn.status);
  }
  const active = btn?.isActive ?? btn?.IsActive;
  if (active === true || active === "true" || active === 1) return "Active";
  if (active === false || active === "false" || active === 0) return "Inactive";
  return "Active";
};

export const buildHeroBannerFormData = (values, isEdit, id) => {
  const payload = new FormData();

  if (isEdit && id) {
    payload.append("Id", id);
    payload.append("id", id);
  }

  payload.append("BannerName", values.bannerName.trim());
  payload.append("bannerName", values.bannerName.trim());
  payload.append("BannerType", values.bannerType);
  payload.append("bannerType", values.bannerType);
  payload.append("BannerTitle", values.bannerTitle.trim());
  payload.append("bannerTitle", values.bannerTitle.trim());

  if (values.bannerDescription?.trim()) {
    payload.append("BannerDescription", values.bannerDescription.trim());
    payload.append("bannerDescription", values.bannerDescription.trim());
  }

  payload.append("DisplayOrder", values.displayOrder);
  payload.append("displayOrder", values.displayOrder);
  payload.append("IsActive", values.isActive ? "true" : "false");
  payload.append("isActive", values.isActive ? "true" : "false");

  if (values.desktopImageUrl) {
    payload.append("DesktopImageUrl", String(values.desktopImageUrl));
  }

  if (values.mobileImageUrl) {
    payload.append("MobileImageUrl", String(values.mobileImageUrl));
  }

  return payload;
};

export const buildButtonPayload = (button, heroBannerId) => {
  const payload = {
    HeroBannerId: heroBannerId,
    heroBannerId: heroBannerId,
    ButtonLabel: button.buttonLabel.trim(),
    buttonLabel: button.buttonLabel.trim(),
    ButtonUrl: button.buttonUrl.trim(),
    buttonUrl: button.buttonUrl.trim(),
    ButtonStyle: button.buttonStyle,
    buttonStyle: button.buttonStyle,
    DisplayOrder: button.displayOrder,
    displayOrder: button.displayOrder,
    ButtonOrder: button.displayOrder,
    buttonOrder: button.displayOrder,
  };

  if (button.id) {
    payload.Id = button.id;
    payload.id = button.id;
  }

  return payload;
};

export const filterButtonsByBannerId = (allButtons, bannerId) =>
  (allButtons || [])
    .filter((btn) => String(getButtonBannerId(btn)) === String(bannerId))
    .sort(
      (a, b) =>
        (a?.displayOrder ?? a?.DisplayOrder ?? 0) -
        (b?.displayOrder ?? b?.DisplayOrder ?? 0)
    );

export const createEmptyButton = (displayOrder = 1) => ({
  clientId: `new-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  id: null,
  buttonLabel: "",
  buttonUrl: "",
  buttonStyle: "",
  displayOrder,
});
